import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResultApi } from '../viewModel/result_api.model';
import { ValoresPlano } from '../viewModel/valores_plano.model';
import {Planos} from '../viewModel/planos.model';
import {
    BASICO,
    BASICO_TRIPLO, BLACK, BLACK_TRIPLO, COMPLETO,
    COMPLETO_TRIPLO, EXCLUSIVO,
    EXCLUSIVO_TRIPLO, IDEAL,
    IDEAL_TRIPLO, PLUS,
    PLUS_TRIPLO, REQUINTE,
    REQUINTE_TRIPLO
} from '../../app.constants';
import {
    BASICO_TEXT,
    BASICO_TEXT_1,
    BASICO_TEXT_2, BLACK_TEXT, BLACK_TEXT_1, BLACK_TEXT_2, COMPLETO_TEXT,
    COMPLETO_TEXT_1,
    COMPLETO_TEXT_2, EXCLUSIVO_TEXT, EXCLUSIVO_TEXT_1, EXCLUSIVO_TEXT_2, IDEAL_TEXT,
    IDEAL_TEXT_1, IDEAL_TEXT_2, PLUS_TEXT, PLUS_TEXT_1, PLUS_TEXT_2, REQUINTE_TEXT, REQUINTE_TEXT_1, REQUINTE_TEXT_2
} from '../constants/planos_text.constant';
import {ACENTOS} from '../constants/acentos.constant';

@Injectable({ providedIn: 'root' })
export class CategoriaPlanoService extends BaseService {

    constructor(private httpClient: HttpClient) {
        super(httpClient, 'categoria-plano');
    }

    public async buscar(plano: string, qtdPessoa: string): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .get<ValoresPlano>(`${this.path()}/listar-valores?plano=${plano}&qtdPessoa=${qtdPessoa}`, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async planos(): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .get<Planos>(`${this.path()}/listar-valores-novos-planos`, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res))
                .catch((err: any) => err);
        } catch (e) {
            return  null;
        }
    }

    public async getListPlanosHome() {
        try {
            const result = await this.planos();
            return this.setListPlanosHome(result.data);
        } catch (err) {
            return null;
        }
    }

    public transitionType(selectedCategoria: string) {
        let result;
        switch (selectedCategoria) {
            case BASICO : {
                result = BASICO_TRIPLO;
                break;
            }
            case BASICO_TRIPLO : {
                result = BASICO;
                break;
            }
            case COMPLETO : {
                result = COMPLETO_TRIPLO;
                break;
            }
            case COMPLETO_TRIPLO : {
                result = COMPLETO;
                break;
            }
            case IDEAL : {
                result = IDEAL_TRIPLO;
                break;
            }
            case IDEAL_TRIPLO : {
                result = IDEAL;
                break;
            }
            case EXCLUSIVO: {
                result = EXCLUSIVO_TRIPLO;
                break;
            }
            case EXCLUSIVO_TRIPLO : {
                result = EXCLUSIVO;
                break;
            }
            case REQUINTE: {
                result = REQUINTE_TRIPLO;
                break;
            }
            case REQUINTE_TRIPLO : {
                result = REQUINTE;
                break;
            }
            case PLUS: {
                result = PLUS_TRIPLO;
                break;
            }
            case PLUS_TRIPLO : {
                result = PLUS;
                break;
            }
            case BLACK: {
                result = BLACK_TRIPLO;
                break;
            }
            case BLACK_TRIPLO : {
                result = BLACK;
                break;
            }
            default: {
                result = selectedCategoria;
                break;
            }
        }
        return result;
    }

    public monthlyValueString(descricao: string) {
        let valor = descricao.split('R$')[1];
        valor = valor.replace('.', ',');
        valor = valor.replace('*', '');
        return 'R$ ' + valor;
    }

    public monthlyValueDiscountString(value: number) {
        const valueSplit = value.toString().split('.');
        if (valueSplit.length < 2 ) {
            return `R$ ${value.toString()},00`;
        }
        if (valueSplit[1].length === 1) {
            return `R$ ${valueSplit[0]},${valueSplit[1]}0`;
        }
        return `R$ ${value.toString().replace('.', ',')}`;
    }

    public getText(textType: number = 0, codigoCategoria: string, valor: string = '') {
        let text;
        switch (codigoCategoria) {
            case BASICO :
            case BASICO_TRIPLO : {
                text = textType === 1 ? BASICO_TEXT_1 : this.getTextWithPrice(BASICO_TEXT_2, valor);
                if (textType === 0) {
                    text = BASICO_TEXT;
                }
                break;
            }
            case COMPLETO :
            case COMPLETO_TRIPLO : {
                text = textType === 1 ? COMPLETO_TEXT_1 : this.getTextWithPrice(COMPLETO_TEXT_2, valor);
                if (textType === 0) {
                    text = COMPLETO_TEXT;
                }
                break;
            }
            case IDEAL :
            case IDEAL_TRIPLO : {
                text = textType === 1 ? IDEAL_TEXT_1 : this.getTextWithPrice(IDEAL_TEXT_2, valor);
                if (textType === 0) {
                    text = IDEAL_TEXT;
                }
                break;
            }
            case EXCLUSIVO:
            case EXCLUSIVO_TRIPLO : {
                text = textType === 1 ? EXCLUSIVO_TEXT_1 : this.getTextWithPrice(EXCLUSIVO_TEXT_2, valor);
                if (textType === 0) {
                    text = EXCLUSIVO_TEXT;
                }
                break;
            }
            case REQUINTE:
            case REQUINTE_TRIPLO : {
                text = textType === 1 ? REQUINTE_TEXT_1 : this.getTextWithPrice(REQUINTE_TEXT_2, valor);
                if (textType === 0) {
                    text = REQUINTE_TEXT;
                }
                break;
            }
            case PLUS:
            case PLUS_TRIPLO : {
                text = textType === 1 ? PLUS_TEXT_1 : this.getTextWithPrice(PLUS_TEXT_2, valor);
                if (textType === 0) {
                    text = PLUS_TEXT;
                }
                break;
            }
            case BLACK:
            case BLACK_TRIPLO : {
                text = textType === 1 ? BLACK_TEXT_1 : this.getTextWithPrice(BLACK_TEXT_2, valor);
                if (textType === 0) {
                    text = BLACK_TEXT;
                }
                break;
            }
            default: {
                text = '';
                break;
            }
        }
        return text;
    }

    public cleanDescriptionTriple(plano: string) {
        try {
            plano = plano.toLowerCase();
            return plano.replace('triplo', '').toLowerCase();
        } catch (err) {
            return null;
        }
    }

    public cleanDescriptionDouble(plano: string) {
        try {
            plano = plano.toLowerCase();
            return plano.replace('duplo', '').toLowerCase();
        } catch (err) {
            return null;
        }
    }
    public onlyTriples(planos: Planos[], min: number = 7) {
        try {
            planos = planos.filter(value => {
                return (
                    value.codigoCategoria !== BASICO    &&
                    value.codigoCategoria !== COMPLETO  &&
                    value.codigoCategoria !== IDEAL     &&
                    value.codigoCategoria !== EXCLUSIVO &&
                    value.codigoCategoria !== REQUINTE  &&
                    value.codigoCategoria !== PLUS      &&
                    value.codigoCategoria !== BLACK
                );
            });
            planos.forEach(value => value.descricao = this.cleanDescriptionTriple(value.descricao.toLowerCase()));
            planos = this.adjustDescription(planos);
            return this.minDiary(planos, min);
        } catch (err) {
            return null;
        }
    }

    public onlyDoubles(planos: Planos[], min: number = 7) {
        try {
            planos = planos.filter(value => {
                return (
                    value.codigoCategoria !== BASICO_TRIPLO    &&
                    value.codigoCategoria !== COMPLETO_TRIPLO  &&
                    value.codigoCategoria !== IDEAL_TRIPLO     &&
                    value.codigoCategoria !== EXCLUSIVO_TRIPLO &&
                    value.codigoCategoria !== REQUINTE_TRIPLO  &&
                    value.codigoCategoria !== PLUS_TRIPLO      &&
                    value.codigoCategoria !== BLACK_TRIPLO
                );
            });
            planos.forEach(value => value.descricao = this.cleanDescriptionDouble(value.descricao.toLowerCase()));
            planos = this.adjustDescription(planos);
            return this.minDiary(planos, min);
        } catch (err) {
            return null;
        }
    }

    public getCodigoPlanoPorNome(plano: string) {
        let result;
        switch (plano) {
            case 'BASICO':
                result = BASICO;
                break;
            case 'COMPLETO':
                result = COMPLETO;
                break;
            case 'IDEAL':
                result = IDEAL;
                break;
            case 'EXCLUSIVO':
                result = EXCLUSIVO;
                break;
            case 'REQUINTE':
                result = REQUINTE;
                break;
            case 'PLUS':
                result = PLUS;
                break;
            case 'BLACK':
                result = BLACK;
                break;
            default:
                result = null;
                break;
        }
        return result;
    }

    public cleanCategoriaDescricao(categoria: string) {
        return categoria.replace(/[\W\[\] ]/g, (word) => ACENTOS[word] || word).toUpperCase().trim();
    }

    private addImage(plano: string) {
        plano = this.cleanDescriptionTriple(plano);
        return [
            'https://www.viagensmontreal.com/design/2021/planos/' + plano + '/' + plano + '_prancheta.jpg',
            'https://www.viagensmontreal.com/design/2021/planos/' + plano + '/' + plano + '_02.jpg',
            'https://www.viagensmontreal.com/design/2021/planos/' + plano + '/' + plano + '_03.jpg',
            'https://www.viagensmontreal.com/design/2021/planos/' + plano + '/' + plano + '_04.jpg',
        ];
    }

    private setImages(planos: Planos[]) {
        try {
            planos.forEach(plano => {
                switch (plano.codigoCategoria) {
                    case BASICO:
                    case BASICO_TRIPLO: {
                        plano.images = this.addImage(plano.descricao.toLowerCase());
                        break;
                    }
                    case COMPLETO:
                    case COMPLETO_TRIPLO: {
                        plano.images = this.addImage(plano.descricao.toLowerCase());
                        break;
                    }
                    case IDEAL:
                    case IDEAL_TRIPLO: {
                        plano.images = this.addImage(plano.descricao.toLowerCase());
                        break;
                    }
                    case EXCLUSIVO:
                    case EXCLUSIVO_TRIPLO: {
                        plano.images = this.addImage(plano.descricao.toLowerCase());
                        break;
                    }
                    case REQUINTE:
                    case REQUINTE_TRIPLO: {
                        plano.images = this.addImage(plano.descricao.toLowerCase());
                        break;
                    }
                    case PLUS:
                    case PLUS_TRIPLO: {
                        plano.images = this.addImage(plano.descricao.toLowerCase());
                        break;
                    }
                    case BLACK:
                    case BLACK_TRIPLO: {
                        plano.images = this.addImage(plano.descricao.toLowerCase());
                        break;
                    }
                    default:
                        throw Error('Plano inválido');
                }
            });
            return planos;
        } catch (err) {
            return null;
        }
    }

    private setListPlanosHome(planos: Planos[], min: number = 7) {
        try {
            planos = this.onlyDoubles(planos, min);
            planos = this.setImages(planos);
            return planos;
        } catch (err) {
            return null;
        }
    }

    private getTextWithPrice(text: string, valor: string) {
        text = text.replace('R$ 000,00', valor);
        return text;
    }

    private adjustDescription(planos: Planos[]) {
        try {
            planos.map((plano) => {
                const desc = plano.descricao.toLowerCase();
                if (desc !== null) {
                    plano.descricao = desc.charAt(0).toUpperCase() + desc.slice(1);
                    if (plano.descricao.trim() === 'Basico') {
                        plano.descricao = 'Básico';
                    }
                }
            });
            return planos;
        } catch (err) {
            return null;
        }
    }

    private minDiary(planos: Planos[], min: number) {
        try {
            planos.forEach((value => {
                if (value.descricao === 'Básico') {
                    value.qtdDiarias = value.qtdDiarias.filter(v => v.quantidadeDiarias >= 7);
                    return;
                }
                value.qtdDiarias = value.qtdDiarias.filter(v => v.quantidadeDiarias >= min);
            }));
            return planos;
        } catch (err) {
            return null;
        }
    }
}
